/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";

import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetSimilarItemsQueryVariables = Types.Exact<{
  skuId: Types.Scalars["ID"]["input"];
}>;

export type GetSimilarItemsQuery = {
  __typename?: "Query";
  shopContent?: {
    __typename?: "ShopContent";
    productDetailsPage?: {
      __typename?: "ShopProductDetailsPage";
      discoveredProductCollectionByTreatmentType: {
        __typename?: "ShopProductDiscoverSkusCollection";
        shopProducts: {
          __typename?: "ShopProductConnection";
          nodes: Array<{
            __typename?: "ShopProduct";
            id: string;
            name: string;
            brand: { __typename?: "Brand"; name: string };
            variantBySkuId?: {
              __typename?: "ShopProductVariant";
              id: string;
              sku: string;
              url: string;
              price: { __typename?: "Money"; value: number; currency: Types.Currency };
              image?: {
                __typename?: "ShopMedia";
                baseUrl: string;
                mediaPath: string;
                altText: string;
              } | null;
              priceMarkdown?: {
                __typename?: "PriceMarkdown";
                fullPrice: { __typename?: "Money"; value: number; currency: Types.Currency };
              } | null;
              promoDiscountOffer?: {
                __typename?: "PromoDiscountOffer";
                displayLabel: { __typename?: "RichText"; formatted: string };
              } | null;
            } | null;
          }>;
        };
      };
    } | null;
  } | null;
};

export type SimilarItemsShopProductFragment = {
  __typename?: "ShopProduct";
  id: string;
  name: string;
  brand: { __typename?: "Brand"; name: string };
  variantBySkuId?: {
    __typename?: "ShopProductVariant";
    id: string;
    sku: string;
    url: string;
    price: { __typename?: "Money"; value: number; currency: Types.Currency };
    image?: {
      __typename?: "ShopMedia";
      baseUrl: string;
      mediaPath: string;
      altText: string;
    } | null;
    priceMarkdown?: {
      __typename?: "PriceMarkdown";
      fullPrice: { __typename?: "Money"; value: number; currency: Types.Currency };
    } | null;
    promoDiscountOffer?: {
      __typename?: "PromoDiscountOffer";
      displayLabel: { __typename?: "RichText"; formatted: string };
    } | null;
  } | null;
};

export const SimilarItemsShopProductFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SimilarItemsShopProduct" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopProduct" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "brand" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variantBySkuId" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "sku" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "price" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "baseUrl" } },
                      { kind: "Field", name: { kind: "Name", value: "mediaPath" } },
                      { kind: "Field", name: { kind: "Name", value: "altText" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "priceMarkdown" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fullPrice" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "promoDiscountOffer" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "input" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "channel" },
                            value: { kind: "EnumValue", value: "SHOP" },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayLabel" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "formatted" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GetSimilarItemsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSimilarItems" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "skuId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "shopContent" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "productDetailsPage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "discoveredProductCollectionByTreatmentType" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "treatment" },
                            value: { kind: "EnumValue", value: "SIMILAR_ITEMS" },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "skuId" },
                            value: { kind: "Variable", name: { kind: "Name", value: "skuId" } },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "shopProducts" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "nodes" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "SimilarItemsShopProduct" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SimilarItemsShopProduct" },
      typeCondition: { kind: "NamedType", name: { kind: "Name", value: "ShopProduct" } },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "brand" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "variantBySkuId" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "sku" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "price" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      { kind: "Field", name: { kind: "Name", value: "currency" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "baseUrl" } },
                      { kind: "Field", name: { kind: "Name", value: "mediaPath" } },
                      { kind: "Field", name: { kind: "Name", value: "altText" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "priceMarkdown" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fullPrice" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "value" } },
                            { kind: "Field", name: { kind: "Name", value: "currency" } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "promoDiscountOffer" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "input" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "channel" },
                            value: { kind: "EnumValue", value: "SHOP" },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayLabel" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "formatted" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetSimilarItemsQuery__
 *
 * To run a query within a React component, call `useGetSimilarItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimilarItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimilarItemsQuery({
 *   variables: {
 *      skuId: // value for 'skuId'
 *   },
 * });
 */
export function useGetSimilarItemsQuery(
  baseOptions: Apollo.QueryHookOptions<GetSimilarItemsQuery, GetSimilarItemsQueryVariables> &
    ({ variables: GetSimilarItemsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSimilarItemsQuery, GetSimilarItemsQueryVariables>(
    GetSimilarItemsDocument,
    options,
  );
}
export function useGetSimilarItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSimilarItemsQuery, GetSimilarItemsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSimilarItemsQuery, GetSimilarItemsQueryVariables>(
    GetSimilarItemsDocument,
    options,
  );
}
// @ts-ignore
export function useGetSimilarItemsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSimilarItemsQuery,
    GetSimilarItemsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetSimilarItemsQuery, GetSimilarItemsQueryVariables>;
export function useGetSimilarItemsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSimilarItemsQuery, GetSimilarItemsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetSimilarItemsQuery | undefined, GetSimilarItemsQueryVariables>;
export function useGetSimilarItemsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSimilarItemsQuery, GetSimilarItemsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSimilarItemsQuery, GetSimilarItemsQueryVariables>(
    GetSimilarItemsDocument,
    options,
  );
}
export type GetSimilarItemsQueryHookResult = ReturnType<typeof useGetSimilarItemsQuery>;
export type GetSimilarItemsLazyQueryHookResult = ReturnType<typeof useGetSimilarItemsLazyQuery>;
export type GetSimilarItemsSuspenseQueryHookResult = ReturnType<
  typeof useGetSimilarItemsSuspenseQuery
>;
export type GetSimilarItemsQueryResult = Apollo.QueryResult<
  GetSimilarItemsQuery,
  GetSimilarItemsQueryVariables
>;
